import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import AuthUser from "../../../Components/AuthUser";
import { useReactToPrint } from "react-to-print";
import http from "../../../http";
import { num } from "../../../converters";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import { reportLang } from "../../../Components/language/pages/reportLang";
import useLanguage from "../../../Components/language/useLanguage";

export default function LedgerIncomeExpenseReport() {
  const { user } = AuthUser();
  const lan = useLanguage(reportLang);
  const date = moment().format("YYYY-MM-DD");
  const [filterData, setFilterData] = useState({
    startDate: date,
    endDate: date,
    brand_id: "",
    ledger_head_id: "",
  });
  const [reportData, setReportData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const handleFilter = (e) => {
    if (filterData.ledger_head_id) {
      http
        .post(`ledger-income-expense-report`, {
          startDate: filterData.startDate,
          endDate: filterData.endDate,
          ledger_head_id: filterData.ledger_head_id,
        })
        .then((res) => {
          console.log(res);
          setReportData(res?.data?.data);
          setTotalAmount(res?.data?.total);
        });
    } else {
      toast.error("Please select ledger");
    }
  };
  const [ledgerHead, setLedgerHead] = useState([]);
  useEffect(() => {
    http.get(`ledger-category`).then((res) => {
      setLedgerHead([{ id: "0", name: "All" }, ...(res.data || [])]);
    });
  }, []);

  const reportRef = useRef();
  const handlePrintTodaysReport = useReactToPrint({
    content: () => reportRef.current,
  });
  console.log(totalAmount, "totalAmount");
  return (
    <div className="page-content">
      <div className="row ms-1">
        <div className="col-lg-12 col-md-4 requisition_status_blog">
          <div className="card mb-2 billing_status">
            <div className="row mb-1 p-2">
              <div className="row col-11">
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-4">
                      <label>{lan?.startDate}</label>
                    </div>
                    <div className="col-8">
                      <ReactDatePicker
                        placeholderText="From Date"
                        selected={
                          filterData.startDate
                            ? new Date(filterData.startDate)
                            : new Date()
                        }
                        className="form-control form-control-sm custom-datepicker-input-width"
                        dateFormat={"dd/MM/yyyy"}
                        name="requisition_no"
                        onChange={(d) =>
                          setFilterData({
                            ...filterData,
                            startDate: moment(d).format("YYYY-MM-DD"),
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-4">
                      <label>{lan?.endDate}</label>
                    </div>
                    <div className="col-8">
                      <ReactDatePicker
                        placeholderText="From Date"
                        selected={
                          filterData.endDate
                            ? new Date(filterData.endDate)
                            : new Date()
                        }
                        className="form-control form-control-sm custom-datepicker-input-width"
                        dateFormat={"dd/MM/yyyy"}
                        name="requisition_no"
                        onChange={(d) =>
                          setFilterData({
                            ...filterData,
                            endDate: moment(d).format("YYYY-MM-DD"),
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="row">
                    <div className="col-2">
                      <label>{lan?.ledger}</label>
                    </div>
                    <div className="col-10">
                      <Select
                        options={ledgerHead}
                        placeholder={lan?.selectLedger}
                        onChange={(d) =>
                          setFilterData({
                            ...filterData,
                            ledger_head_id: d?.id,
                          })
                        }
                        getOptionLabel={(unPaidInvoices) =>
                          `${unPaidInvoices.name}`
                        }
                        getOptionValue={(unPaidInvoices) =>
                          `${unPaidInvoices.id}`
                        }
                        value={ledgerHead?.filter(
                          (unPaidInvoices) =>
                            unPaidInvoices.id ==
                            Number(filterData?.ledger_head_id)
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-1">
                <button
                  style={{
                    backgroundColor: "#69B128",
                    color: "white",
                    paddingTop: "6px",
                    paddingBottom: "7px",
                    marginTop: "1px",
                  }}
                  onClick={handleFilter}
                  className="btn btn-sm px-4 fw-bold"
                >
                  {lan?.search}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="me-1">
        <div className="custom-card p-2 report-table-wrapper g-doc-scroll">
          <div className="d-flex justify-content-between">
            <h6>{lan?.incomeAndExpenditureReport}</h6>
            <button
              onClick={handlePrintTodaysReport}
              className="btn btn-sm btn-primary float-end"
            >
              {lan?.print}
            </button>
          </div>
          <div className="mt-3">
            <div ref={reportRef} className="daily-sales-report-table">
              <div className="daily-report">
                {/* <div className="d-flex justify-content-center">
                  <div className="text-center">
                    <h5 className="report-org-name">
                      {user?.organization?.name}
                    </h5>
                    <p className="report-org-address">
                      {" "}
                      {user?.organization?.address}
                    </p>
                    <p>Tel : {user?.organization?.mobile}</p>
                  </div>
                </div> */}
                <div className="invoice-pharmacy-details d-flex align-items-center">
                  <img
                    src={user?.organization?.logo}
                    className="img-fluid"
                    style={{ height: "80px" }}
                    alt=""
                  />
                  <div className="text-center flex-grow-1">
                    <div style={{ marginLeft: "-80px" }}>
                      <h5>{user?.organization?.name}</h5>
                      <p>Location : {user?.organization?.address}</p>
                      <p>Tel : {user?.organization?.mobile}</p>
                      <h6 className="mt-2">{lan?.invoice}</h6>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-2">
                  <h6>{lan?.incomeAndExpenditureReport} </h6>
                  {filterData.startDate && filterData.endDate && (
                    <h6>
                      Dated: {moment(filterData.startDate).format("DD/MM/YYYY")}{" "}
                      to {moment(filterData.endDate).format("DD/MM/YYYY")}
                    </h6>
                  )}
                  {!filterData.startDate && !filterData.endDate && (
                    <h6>Dated: {moment(new Date()).format("DD/MM/YYYY")}</h6>
                  )}
                </div>
              </div>
              <table className="mt-2">
                <tbody>
                  <tr className="bg-light">
                    <td>{lan?.sl}</td>
                    <td>{lan?.date}</td>
                    <td>{lan?.category}</td>
                    <td>{lan?.code}</td>
                    <td>{lan?.name}</td>
                    <td className="text-end">{lan?.amount}</td>
                  </tr>
                  {reportData?.map((item, i) => (
                    <>
                      <tr key={i}>
                        <td width="5%">{i + 1}</td>
                        <td className="text-start" width="9%">
                          {moment(item?.transaction_date).format("DD/MM/YYYY")}
                        </td>
                        <td width="" className="text-start">
                          {item?.category?.name}
                        </td>
                        <td width="" className="text-start">
                          {item?.ledger?.ledger_code}
                        </td>
                        <td width="" className="text-start">
                          {item?.ledger?.name}
                        </td>
                        <td width="" className="text-end">
                          {parseFloat(item?.amount || 0).toFixed(2)}
                        </td>
                      </tr>
                    </>
                  ))}

                  <tr>
                    <td colSpan={5} className="text-end fw-bold">
                      {" "}
                      {lan?.totalAmount} :{" "}
                    </td>
                    <td className="text-end fw-bold">
                      {parseFloat(totalAmount || 0).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
